import PropTypes from 'prop-types';
import { MediaQuery } from '@spotahome/ui-library';
import { HomecardFormatter } from '@spotahome/ui-library/src/tenant/utils/images';

import Homecard from '@spotahome/marketplace-common/src/components/Homecard';
import { getMonthlyPrice } from '@spotahome/marketplace-common/src/utils/homecards';
import { TRACKING_PAGE_TYPES } from '@spotahome/ecommerce-tracking/src/constants';

import './HomecardGrid.scss';

const isAvailableFromYear = firstAvailableDate => {
  const currentYear = new Date().getFullYear();
  const firstAvailableYear = new Date(firstAvailableDate).getFullYear();

  return firstAvailableYear !== currentYear;
};

const HomecardGrid = ({ homecards = [], preloadedHomecards }) => {
  return (
    <div className="l-list">
      {homecards.map((homecard, position) => (
        <div
          className="l-list__item"
          data-homecard-scroll={homecard.id}
          key={homecard.id}
        >
          <Homecard
            data={{
              ...homecard,
              photos: HomecardFormatter.getPhotos(
                homecard.photoIds,
                homecard.otherPropertyPhotoIds
              ),
              photoUrls: HomecardFormatter.getPhotoUrls(homecard.photoIds),
              monthlyPrice: getMonthlyPrice(homecard.displayPrice)
            }}
            position={position}
            pageType={TRACKING_PAGE_TYPES.SEO_LANDING_PAGE}
            isShowStatus
            flexibleMoveOut={false}
            flexibleMoveIn={false}
            reviews={homecard.reviews}
            showPrice
            newTab={!MediaQuery.isBiggerThanPhablet()}
            showAvailableFromYear={isAvailableFromYear(
              homecard.firstAvailableDate
            )}
            showSquaredMeters
            hasLazyLoad={!preloadedHomecards.includes(homecard.id)}
          />
        </div>
      ))}
    </div>
  );
};

HomecardGrid.propTypes = {
  homecards: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  preloadedHomecards: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default HomecardGrid;
